import { render, staticRenderFns } from "./RefinementFilterScreen.vue?vue&type=template&id=7956d1e4&scoped=true&"
import script from "./RefinementFilterScreen.vue?vue&type=script&lang=js&"
export * from "./RefinementFilterScreen.vue?vue&type=script&lang=js&"
import style0 from "./RefinementFilterScreen.vue?vue&type=style&index=0&id=7956d1e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7956d1e4",
  null
  
)

export default component.exports